import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useConfig } from "../ConfigContext.js";
// import Schema from "../Schema/WebPage_Schema.js";
import Schema from "../Schema/Schema.js";
import { brandSchema, medicalOrganizationSchema } from "../Schema/Schemas.js";
import "../../assets/css/NewHeader.css"


import BookingScanPopup from "../BookingScanPopup.js";

const PhoneDropdown = () => { 
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  /* close on outside click (mobile tap-away) */
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div
      ref={ref}
      className="relative flex items-center"
      /* desktop: open on hover */
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {/* ── Trigger button (matches existing lk2 ring style) ── */}
      <button
        aria-label="Call us"
        onClick={() => setOpen((o) => !o)}
        className="lk2 flex items-center justify-center focus:outline-none"
      >
        {/* phone SVG — same ring animation already on .lk2 */}

        {/* desktop: show number on md+ */}
        {/* <span className="hidden md:inline ml-2 text-sm font-semibold">
          1800-309-5252
        </span> */}
        <span className="hidden md:inline ml-2 text-sm font-semibold">
          Call Us
        </span>
      </button>

      {/* ── Dropdown card ── */}
      <div
        className={`
          absolute top-full right-0  left-[-45px] md:left-[-10px] mt-2 z-[9999]
          w-64 rounded-2xl shadow-2xl overflow-hidden
          bg-white border border-purple-100
          transition-all duration-200 ease-out origin-top-right
          ${open ? "opacity-100 scale-100 pointer-events-auto" : "opacity-0 scale-95 pointer-events-none"}
        `}
      >
        {/* header strip */}
        <div className="bg-gradient-to-r from-[#8F61D4] to-[#C4A9FE] px-4 py-3">
          <p className="text-white text-xs font-semibold uppercase tracking-wider">
            Contact Us
          </p>
        </div>

        {/* Patient row */}
        <a
          href="tel:18003095252"
          className="flex items-center gap-3 px-4 py-3 hover:bg-purple-50 transition-colors group border-b border-gray-100"
          onClick={() => setOpen(false)}
        >
          <div className="w-9 h-9 rounded-full bg-purple-100 flex items-center justify-center shrink-0 group-hover:bg-purple-200 transition-colors">
            <svg className="w-4 h-4 text-[#7D65AC]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM12 14a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7z" />
            </svg>
          </div>
          <div className="min-w-0">
            <p className="text-[11px] font-medium text-gray-400 uppercase tracking-wide leading-none mb-0.5">
              For Patients
            </p>
            <p className="text-[15px] font-bold text-gray-800 group-hover:text-[#7D65AC] transition-colors">
              1800-309-5252
            </p>
          </div>
          <svg className="w-4 h-4 text-gray-300 ml-auto group-hover:text-[#7D65AC] transition-colors shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </a>

        {/* Doctor row */}
        <a
          href="tel:8800013241"
          className="flex items-center gap-3 px-4 py-3 hover:bg-purple-50 transition-colors group"
          onClick={() => setOpen(false)}
        >
          <div className="w-9 h-9 rounded-full bg-purple-100 flex items-center justify-center shrink-0 group-hover:bg-purple-200 transition-colors">
            <svg className="w-4 h-4 text-[#7D65AC]" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2" />
            </svg>
          </div>
          <div className="min-w-0">
            <p className="text-[11px] font-medium text-gray-400 uppercase tracking-wide leading-none mb-0.5">
              For Doctors
            </p>
            <p className="text-[15px] font-bold text-gray-800 group-hover:text-[#7D65AC] transition-colors">
              880-001-3241
            </p>
          </div>
          <svg className="w-4 h-4 text-gray-300 ml-auto group-hover:text-[#7D65AC] transition-colors shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </div>
  );
};

const NewHeader = () => {
  const [isActive, setActive] = useState(false);
  const [isActiveSubMenu, setActiveSubMenu] = useState(false);
  const [isActiveSecondSubMenu, setActiveSecondSubMenu] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { productTypeData, treatmentTypeData } = useConfig();
  const location = useLocation();

  useEffect(() => {
    document.body.classList.remove("menu-open");

    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".mb_menu") &&
        !event.target.closest(".btn_menu")
      ) {
        closeToggle();
      }
    };

    document.body.addEventListener("click", handleClickOutside);

    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const closeToggle = () => {
    if (window.innerWidth > 1200) {
      document.querySelector(".hdr_mn").classList.remove("active");
      document.body.classList.remove("menu-open");
      document.querySelector(".mb_menu .close_menu").classList.remove("active");
      document.querySelector("header .new-blackbg").classList.remove("active");
    } else {
      document.body.classList.remove("menu-open");
      document.querySelector(".mb_menu").classList.remove("active");
      document.querySelector(".mb_menu .close_menu").classList.remove("active");
      document.querySelector("header .new-blackbg").classList.remove("active");
    }
  };

  const toggleClass = () => {
    if (window.innerWidth > 1200) {
      if (document.querySelector(".hdr_mn").classList.contains("active")) {
        document.querySelector(".hdr_mn").classList.remove("active");
        document.body.classList.remove("menu-open");
        document.querySelector("header .new-blackbg").classList.remove("active");
        document
          .querySelector(".mb_menu .close_menu")
          .classList.remove("active");
      } else {
        document.querySelector(".hdr_mn").classList.add("active");
        document.body.classList.add("menu-open");
        document.querySelector("header .new-blackbg").classList.add("active");
        document.querySelector(".mb_menu .close_menu").classList.add("active");
      }
    } else {
      if (document.querySelector(".mb_menu").classList.contains("active")) {
        document.body.classList.remove("menu-open");
        document.querySelector(".mb_menu").classList.remove("active");
        document.querySelector(".mb_menu").style.display = "none";
        document.querySelector("header .new-blackbg").classList.remove("active");
        document
          .querySelector(".mb_menu .close_menu")
          .classList.remove("active");
        document.querySelector(".hdr_mn").classList.remove("active");

      } else {
        document.body.classList.add("menu-open");
        document.querySelector(".mb_menu").classList.add("active");
        document.querySelector(".mb_menu").style.display = "block";
        document.querySelector("header .new-blackbg").classList.add("active");
        document.querySelector(".mb_menu .close_menu").classList.add("active");
        document.querySelector(".hdr_mn").classList.add("active");
      }
    }
  };

  const handleSecondMenuClick = () => {
    setActiveSecondSubMenu(!isActiveSecondSubMenu);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const body = document.querySelector("body");
      if (scrollTop > 48) {
        body.classList.add("scroll");
      } else {
        body.classList.remove("scroll");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "i46otsi5xp");
  }, []);

  const handleMenuClick = () => {
    setActiveSubMenu(!isActiveSubMenu);
  };
  const handleProductClick = (newPath) => {
    closeToggle();
  };
  return (
    <>
      {/* {<Schema />} */}
      <Schema schemaData={medicalOrganizationSchema} />
      <Schema schemaData={brandSchema} />


      <header className="new-header">
        <div className="container clearfix">
          <Link to="/" className="lt">
            <img
              src="/images/whistle-logo.webp"
              alt="logo-img"
              fetchpriority="high"
              loading="lazy"
            />
          </Link>

          <div className="new-blackbg bg-transparent"></div>
          <div className="mb_menu">
            <img
              onClick={closeToggle}
              className="close_menu new_close_menu"
              src="/images/circle.webp"
              alt="close-img"
              fetchpriority="high"
              loading="lazy"
            />

            <div className="hdr_mn new_hdr_mn hide-scrollbar">
              <div className="container">
                <div className="dv_fst">
                  <p className="new_hdr_head">Menu</p>
                </div>
                <div className="dv_tp">

                  <div className="md_new clearfix">
                    <div
                      className={
                        isActiveSubMenu ? "mn has_menu active" : "mn has_menu"
                      }
                      onClick={handleMenuClick}
                    >
                      <Link className="lk first">Products</Link>
                      <div
                        className={isActiveSubMenu ? "mn_lk active" : "mn_lk"}
                      >
                        {productTypeData.map((item, index) => (
                          <Link
                            onClick={() => handleProductClick(item.name)}
                            key={index}
                            to={`/${item.slug.toLowerCase()}`}
                          >
                            {item.name}
                          </Link>
                        ))}
                      </div>
                    </div>

                    <div
                      className={
                        isActiveSecondSubMenu
                          ? "mn has_menu active"
                          : "mn has_menu"
                      }
                      onClick={handleSecondMenuClick}
                    >
                      <Link className="lk">Treatments</Link>
                      <div
                        className={
                          isActiveSecondSubMenu ? "mn_lk active" : "mn_lk"
                        }
                      >
                        {treatmentTypeData
                          ?.filter((treat) => treat.linking_status === 1)
                          .map((treat, index) => (
                            <Link key={index} to={`/treatment/${treat.treatment_slug}`}>
                              {treat.treatment_name}
                            </Link>
                          ))}
                        <Link to="/treatment" className="ttl">
                          All Treatments
                        </Link>
                      </div>
                    </div>

                    <div className="mn">
                      <Link to="/location" className="lk">
                        Find a Clinic
                      </Link>
                    </div>
                    {/* <div className="mn">
                      <Link to="/orthodontist" className="lk">
                        Find an Orthodontist
                      </Link>
                    </div>  */}
                    <div className="mn">
                      <div className="lk"
                      // onClick={() => setIsOpen(true)}
                      >
                        <Link to="/appointment">
                          Appointment
                        </Link>
                      </div>
                    </div>
                  </div>
                  <Link to="https://smile.whistle.in/">Smile Predictor</Link>
                  <Link to="/transformation">Transformation</Link>
                  <Link to="/about-us">Who We Are</Link>
                  <Link to="/media">Media</Link>
                  {/* <Link to="/blog">Our Blogs</Link> */}
                  <Link to="/careers">Careers</Link>
                  <Link to="/partners">Partner with us</Link>
                  
                  {/* <Link to="/orthodontist-partners">Parther with orthodontist</Link> */}

                  {/* <Link to= "/testimonials">Testimonials</Link> */}
                  <Link to="/location">Location</Link>
                  <Link to="/faqs">FAQs</Link>
                  <Link to="/blog">Blogs</Link>
                </div>

              </div>
            </div>
          </div>

          <div className="rt">
            {/* <Link className="normal-lk hidden md:flex" to="/orthodontist-partners">
              <span>Find an orthodontist</span>
            </Link> */}
            <Link className="normal-lk hidden md:flex" to="/partners">
              <span>PARTNER WITH US</span>
            </Link>
            {location.pathname !== "/thank-you" && (
              <PhoneDropdown />
            )}
            <Link className="new-lk" to="/appointment">
              <span>Appointment</span>
            </Link>

            <div
              className={isActive ? "btn_menu active" : "btn_menu btn_menu_new"}
              onClick={toggleClass}
            >
              {/* <span>Menu</span> */}
            </div>
          </div>
        </div>

        <BookingScanPopup
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          selectedProduct={0}
        />
      </header>
    </>
  );
};

export default NewHeader;
